import { render, staticRenderFns } from "./bannerSetting.vue?vue&type=template&id=7f12b614&scoped=true&"
import script from "./bannerSetting.vue?vue&type=script&lang=js&"
export * from "./bannerSetting.vue?vue&type=script&lang=js&"
import style0 from "./bannerSetting.vue?vue&type=style&index=0&id=7f12b614&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7f12b614",
  null
  
)

export default component.exports